<template>
  <section class="container-nav">
    <nav>
      <router-link class="navbar" to="/">
        <img
          alt="Grub's up logo"
          height="80"
          width="80"
          src="@/assets/logo.svg"
        />
        <span class="nav-title">Grub’s up</span>
      </router-link>
    </nav>
  </section>
</template>